import { render, staticRenderFns } from "./ItemPriceField.vue?vue&type=template&id=55881809&scoped=true&"
import script from "./ItemPriceField.vue?vue&type=script&lang=js&"
export * from "./ItemPriceField.vue?vue&type=script&lang=js&"
import style0 from "./ItemPriceField.vue?vue&type=style&index=0&id=55881809&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55881809",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
